import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from "vue";
import { QDraggableList, QButton } from "../../../shared";
import { Category } from "../types/Category";

type DraggableItem = Category & { children?: DraggableItem[] };


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
	items: {
		type: Array as PropType<Category[]>,
		required: true,
	},
},
  emits: ["update:items", "error", "edit", "delete", "addSubcategory"],
  setup(__props, { emit }: { emit: ({
	(e: "update:items", items: Category[]): void
	(e: "error", errorMessage: string): void
	(e: "edit", category: Category): void
	(e: "delete", category: Category): void
	(e: "addSubcategory", category: Category): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





function copy<T>(obj: T): T {
	return JSON.parse(JSON.stringify(obj));
}

function itemsToDraggable(items: Category[]) {
	return (copy(items) as DraggableItem[])
		.sort((a, b) => a.order - b.order)
		.reduce((acc, item, index, items) => {
			if (item.parent_category_id) {
				const parent = items.find(
					(i) => i.id === item.parent_category_id
				);
				if (parent) {
					if (!parent.children) parent.children = [];
					parent.children.push(item);
				}
			} else {
				if (!item.children) item.children = [];
				acc.push(item);
			}
			return acc;
		}, [] as DraggableItem[]);
}

const draggableToItems = (items: DraggableItem[]) => {
	const arr: Category[] = [];

	const deeplyPush = (
		item: DraggableItem,
		order: number,
		parent: number | null = null
	) => {
		if (item.children) {
			item.children.forEach((child, index) =>
				deeplyPush(child, index, item.id)
			);
		}

		arr.push({
			...item,
			parent_category_id: parent,
			order: order,
		});
	};

	items.forEach((item, index) => {
		deeplyPush(item, index);
	});

	return arr;
};

const validateNewItems = (items: DraggableItem[]) => {
	let errors: string[] = [];
	items.forEach((topLevelCategory) => {
		if (!topLevelCategory.children) {
			return;
		}

		const parents = topLevelCategory.children.filter(
			(child) => child.children && child.children.length > 0
		);

		parents.forEach((parent) => {
			if (parent.children && parent.children.length > 0) {
				errors.push(
					`"${topLevelCategory.category}" can not contain "${parent.category}" with subcategories`
				);
			}
		});
	});
	return errors;
};

const draggableItems = computed({
	get() {
		return itemsToDraggable(props.items);
	},
	set(items) {
		const newItems = draggableToItems(items);

		const errors = validateNewItems(newItems);
		if (errors.length > 0) {
			emit("error", errors.join(", "));
			emit("update:items", props.items)
			return;
		}

		emit('update:items', newItems)
	},
});

const itemToCategory = (item: DraggableItem) => {
	return props.items.find((i) => i.id === item.id);
}

const isSupportCategory = (category: Category) => {
	return category.zendesk_category_id !== null && category.zendesk_category_id > 0;
}

return { __sfc: true,props, emit, copy, itemsToDraggable, draggableToItems, validateNewItems, draggableItems, itemToCategory, isSupportCategory, QDraggableList, QButton }
}

})